<script>
import resources from './resources'

export default {
  name: 'change-password',
  mixins: [resources],
  resourcePath: '/v1/settings/users/me/password',
  data () {
    return {
      show: false
    }
  }
}
</script>

<template lang="pug">
.collapsible-2.collapse
  .form-group.panel-body
    medibook-alert(:show='show',
    @hide='show = false',
    button-action="OK!",
    message='Sua senha foi alterada com sucesso.')
    .row.senhas
      .col-xs-12.col-sm-4.margin-bottom
        label(for='senha')
          | Senha Atual
          br
        f-text(
          type="password",
          v-model="password.current_password",
          :errors="errors['current_password']"
          label="")

      .col-xs-12.col-sm-4
        f-text(
          type="password",
          v-model="password.password",
          :errors="errors['password']",
          label="Nova senha")

      .col-xs-12.col-sm-4
        f-text(
          type="password",
          v-model="password.confirmed",
          :errors="errors['confirmed']",
          label="Confirme sua nova senha")
    .row
      .col-xs-12.col-sm-12.margin-bottom
        small.text-muted.senha-tip
          strong A senha deve conter 1 número e no mínimo 8 caracteres.
    button.btn.save.pull-right(@click.prevent="doSave()")
      span.icon 
      |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/settings/profile/components/change-password.vue